module.exports = __webpack_public_path__ + "static/xylophone_affirm1.65e3a032.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/xylophone_affirm1.wav
// module id = 127
// module chunks = 105603797122985 114276838955818 126609682503911 252234152318474